import React, { useState, useEffect } from 'react';

interface NavigationProps {
  activeSection: string;
}

const Navigation: React.FC<NavigationProps> = ({ activeSection }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const maxScroll = 100; // Maximum scroll amount for full blur
      const progress = Math.min(scrollY / maxScroll, 1);
      setScrollProgress(progress);
      setIsScrolled(scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      // Update URL hash
      window.history.pushState(null, '', `#${sectionId}`);
      // Close mobile menu after clicking
      setIsMobileMenuOpen(false);
    }
  };

  const navStyle = {
    background: `rgba(255, 255, 255, ${scrollProgress * 0.1})`,
    backdropFilter: `blur(${scrollProgress * 10}px)`,
  };

  return (
    <header className={`navigation ${isScrolled ? 'scrolled' : ''}`} style={navStyle}>
      <div className="nav-container">
        <div className="header-left">
          <img src="assets/maze.png" className="maze-icon" alt="Maze Logo" />
          <div className="logo-text">
            <div>Lattice</div>
            <div>Research</div>
          </div>
        </div>
        <button 
          className={`hamburger-menu ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <nav className={`nav-links ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          {[
            { id: 'services', label: 'Services' },
            { id: 'contact', label: 'Contact' }
          ].map((section) => (
            <a
              key={section.id}
              href={`#${section.id}`}
              className={`nav-link-box${activeSection === section.id ? ' active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                scrollToSection(section.id);
              }}
            >
              {section.label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Navigation; 